import api from '../lib/api';

/** Một hũ như web thấy: giá trị hiện tại + mốc nổ gần nhất. */
export interface JackpotGameView {
  game: 'tx' | 'xd' | 'tl';
  name: string;
  jackpot: number;
  /** ISO — `undefined` nếu chưa ghi nhận lần nổ nào (cold start). */
  lastHitAt?: string;
  lastValue?: number;
}

export interface JackpotView {
  status: 'connecting' | 'connected' | 'disconnected';
  updatedAt: string | null;
  games: JackpotGameView[];
}

export const jackpotService = {
  /** Ảnh chụp hũ 3 game + mốc nổ (đọc lúc mở app; realtime sau đó qua SSE). */
  async getState(): Promise<JackpotView> {
    // Backend bọc `{ status, code, message, data }` — lấy phần `data`.
    const res = await api.get<{ data: JackpotView }>('/api/v1/jackpot');
    return res.data.data;
  },
};
